import { render, staticRenderFns } from "./cadclassesimpostos.vue?vue&type=template&id=2275bc42&"
import script from "./cadclassesimpostos.vue?vue&type=script&lang=js&"
export * from "./cadclassesimpostos.vue?vue&type=script&lang=js&"
import style0 from "./cadclassesimpostos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports